<template>
	<main class="deal-overview" v-if="token">
		<!-- Header -->
		<div class="deal-overview__header">
			<router-link :to="{ name: 'PrivateRaise' }" class="back-link">
				<svg width="20" height="20" viewBox="0 0 24 24" fill="none">
					<path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
				Back to Private Raise
			</router-link>
			<router-link
				:to="{ name: 'ConfigurePrivateRaise', params: { type: 'private-raise' } }"
				class="btn btn--primary"
			>
				<svg width="18" height="18" viewBox="0 0 24 24" fill="none">
					<path d="M12.22 2H11.78C11.2496 2 10.7409 2.21071 10.3658 2.58579C9.99072 2.96086 9.78 3.46957 9.78 4V4.18C9.77964 4.53073 9.68706 4.87519 9.51154 5.17884C9.33602 5.48248 9.08374 5.7347 8.78 5.91L8.35 6.16C8.04596 6.33554 7.70108 6.42795 7.35 6.42795C6.99892 6.42795 6.65404 6.33554 6.35 6.16L6.2 6.08C5.74107 5.81526 5.19584 5.74344 4.684 5.88031C4.17217 6.01717 3.73555 6.35154 3.47 6.81L3.25 7.19C2.98526 7.64893 2.91345 8.19416 3.05031 8.706C3.18717 9.21783 3.52154 9.65445 3.98 9.92L4.13 10.02C4.43228 10.1945 4.68362 10.4451 4.85905 10.7468C5.03448 11.0486 5.1279 11.391 5.13 11.74V12.25C5.1314 12.6024 5.03965 12.949 4.86405 13.2545C4.68844 13.5601 4.43521 13.8138 4.13 13.99L3.98 14.08C3.52154 14.3455 3.18717 14.7822 3.05031 15.294C2.91345 15.8058 2.98526 16.3511 3.25 16.81L3.47 17.19C3.73555 17.6485 4.17217 17.9828 4.684 18.1197C5.19584 18.2566 5.74107 18.1847 6.2 17.92L6.35 17.84C6.65404 17.6645 6.99892 17.5721 7.35 17.5721C7.70108 17.5721 8.04596 17.6645 8.35 17.84L8.78 18.09C9.08374 18.2653 9.33602 18.5175 9.51154 18.8212C9.68706 19.1248 9.77964 19.4693 9.78 19.82V20C9.78 20.5304 9.99072 21.0391 10.3658 21.4142C10.7409 21.7893 11.2496 22 11.78 22H12.22C12.7504 22 13.2591 21.7893 13.6342 21.4142C14.0093 21.0391 14.22 20.5304 14.22 20V19.82C14.2204 19.4693 14.3129 19.1248 14.4885 18.8212C14.664 18.5175 14.9163 18.2653 15.22 18.09L15.65 17.84C15.954 17.6645 16.2989 17.5721 16.65 17.5721C17.0011 17.5721 17.346 17.6645 17.65 17.84L17.8 17.92C18.2589 18.1847 18.8042 18.2566 19.316 18.1197C19.8278 17.9828 20.2645 17.6485 20.53 17.19L20.75 16.81C21.0147 16.3511 21.0866 15.8058 20.9497 15.294C20.8128 14.7822 20.4785 14.3455 20.02 14.08L19.87 13.99C19.5648 13.8138 19.3116 13.5601 19.136 13.2545C18.9604 12.949 18.8686 12.6024 18.87 12.25V11.75C18.8686 11.3976 18.9604 11.051 19.136 10.7455C19.3116 10.4399 19.5648 10.1862 19.87 10.01L20.02 9.92C20.4785 9.65445 20.8128 9.21783 20.9497 8.706C21.0866 8.19416 21.0147 7.64893 20.75 7.19L20.53 6.81C20.2645 6.35154 19.8278 6.01717 19.316 5.88031C18.8042 5.74344 18.2589 5.81526 17.8 6.08L17.65 6.16C17.346 6.33554 17.0011 6.42795 16.65 6.42795C16.2989 6.42795 15.954 6.33554 15.65 6.16L15.22 5.91C14.9163 5.7347 14.664 5.48248 14.4885 5.17884C14.3129 4.87519 14.2204 4.53073 14.22 4.18V4C14.22 3.46957 14.0093 2.96086 13.6342 2.58579C13.2591 2.21071 12.7504 2 12.22 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
					<circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.5"/>
				</svg>
				{{ token && token.status === "Pending" ? "Configure" : "View Config" }}
			</router-link>
		</div>

		<!-- Deal Title -->
		<div class="deal-title">
			<img :src="token.image" :alt="token.name" class="deal-title__image" />
			<h1 class="deal-title__name">{{ token.name }}</h1>
		</div>

		<!-- Stats Grid -->
		<div class="stats-grid">
			<!-- Amount Raised Card -->
			<div class="stat-card stat-card--primary">
				<div class="stat-card__content">
					<div class="stat-card__main">
						<div class="stat-card__icon-wrap">
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
								<path d="M23 6L13.5 15.5L8.5 10.5L1 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M17 6H23V12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
						</div>
						<div>
							<p class="stat-card__label">Amount Raised</p>
							<p class="stat-card__value">{{ formatAmountToDollar(totalRaised, 2, currency) }}</p>
							<div class="stat-card__progress">
								<div class="progress-bar">
									<div class="progress-bar__fill" :style="{ width: percentageRaised + '%' }"></div>
								</div>
								<span class="stat-card__percentage">{{ percentageRaised }}% of goal</span>
							</div>
						</div>
					</div>
					<div class="stat-card__secondary">
						<p class="stat-card__label">Token Price</p>
						<p class="stat-card__value-sm">{{ formatAmountToDollar(token.price.exchange || token.price.buy, 2, currency) }} / token</p>
					</div>
				</div>
				<div class="stat-card__footer">
					<div class="stat-item" v-if="token.investment_type === 'Debt'">
						<span class="stat-item__label">Investment Type</span>
						<span class="stat-item__value">{{ token.investment_type }}</span>
					</div>
					<div class="stat-item" v-else>
						<span class="stat-item__label">Market Cap</span>
						<span class="stat-item__value">{{ formatAmountToDollar(token.valuation, 2, currency) }}</span>
					</div>
				</div>
			</div>

			<!-- Members Card -->
			<div class="stat-card" v-if="dealAccess === 'Private'">
				<div class="stat-card__header">
					<div class="stat-card__icon-sm">
						<svg width="20" height="20" viewBox="0 0 24 24" fill="none">
							<path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
							<circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="1.5"/>
							<path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					</div>
					<div>
						<p class="stat-card__label">Membership Strength</p>
						<p class="stat-card__value" v-if="dealMembers">{{ convertToLocale(dealMembers?.length) }}</p>
					</div>
				</div>
				<div class="stat-card__body">
					<button
						@click="showMemberForm = true"
						v-if="dealMembers && dealMembers.length === 0 && token.deal_access === 'Private'"
						class="btn btn--primary btn--full"
					>
						<svg width="18" height="18" viewBox="0 0 24 24" fill="none">
							<path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
						Add Member
					</button>
					<div class="members-list" v-else>
						<div class="members-list__avatars">
							<MemberIcon
								v-for="(member, index) in selectedMembers"
								:key="member._id"
								:index="index"
								:member="member.user"
								class="members-list__avatar"
							/>
							<button
								@click="showMemberForm = true"
								class="members-list__add"
							>
								<svg width="16" height="16" viewBox="0 0 24 24" fill="none">
									<path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<AddMember v-if="showMemberForm" @show-member-form="handleMember" />

		<!-- Tabs Section -->
		<div class="content-card" v-if="token && token.token">
			<div class="content-card__header">
				<nav class="tabs-nav">
					<button
						class="tabs-nav__item"
						v-if="token && token.token"
						:class="{ 'tabs-nav__item--active': currentSection === 'DealTransactionTable' }"
						@click="currentSection = 'DealTransactionTable'"
					>
						<svg width="18" height="18" viewBox="0 0 24 24" fill="none">
							<path d="M12 2V22M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
						Transactions
					</button>
					<button
						class="tabs-nav__item"
						:class="{ 'tabs-nav__item--active': currentSection === 'Members' }"
						v-if="token && token.deal_access === 'Private' && token.token"
						@click="currentSection = 'Members'"
					>
						<svg width="18" height="18" viewBox="0 0 24 24" fill="none">
							<path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
							<circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="1.5"/>
						</svg>
						Members
					</button>
					<button
						class="tabs-nav__item"
						v-if="token && token?.token"
						:class="{ 'tabs-nav__item--active': currentSection === 'Investors' }"
						@click="currentSection = 'Investors'"
					>
						<svg width="18" height="18" viewBox="0 0 24 24" fill="none">
							<path d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
							<circle cx="8.5" cy="7" r="4" stroke="currentColor" stroke-width="1.5"/>
							<path d="M20 8V14M17 11H23" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
						Investors
					</button>
					<button
						v-if="token?.token"
						class="tabs-nav__item"
						:class="{ 'tabs-nav__item--active': currentSection === 'DealOrderBookTable' }"
						@click="currentSection = 'DealOrderBookTable'"
					>
						<svg width="18" height="18" viewBox="0 0 24 24" fill="none">
							<path d="M4 19.5V4.5C4 3.83696 4.26339 3.20107 4.73223 2.73223C5.20107 2.26339 5.83696 2 6.5 2H20V22H6.5C5.83696 22 5.20107 21.7366 4.73223 21.2678C4.26339 20.7989 4 20.163 4 19.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M4 19.5V19.5C4 18.1193 5.11929 17 6.5 17H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
						Order Book
					</button>
				</nav>
			</div>
			<div class="content-card__body">
				<keep-alive>
					<component
						:spvId="token && token.spv ? token.spv : ''"
						:is="currentSection"
						:tokenId="token ? token.token._id : ''"
						@show-member-form="showMemberForm = true"
					></component>
				</keep-alive>
			</div>
		</div>
	</main>
</template>

<script>
import BackBtn from "@/components/general/BackBtn";
import AddMember from "@/components/privateRaise/AddMember";
import MemberIcon from "@/components/privateRaise/MemberIcon";
import DealOrderBookTable from "@/components/tables/DealOrderBookTable";
import DealTransactionTable from "@/components/tables/DealTransactionTable";
import { convertToLocale, formatAmountToDollar } from "@/utils/helpers.js";
import { mapActions, mapGetters } from "vuex";
import Investors from "./DealInfo/Investors";
import Members from "./DealInfo/Members";
export default {
	name: "PrivateRaiseOverview",
	data() {
		return {
			currentSection: "DealTransactionTable",
			showMemberForm: false,
		};
	},
	components: {
		DealTransactionTable,
		Members,
		Investors,
		DealOrderBookTable,
		AddMember,
		BackBtn,
		MemberIcon,
	},
	computed: {
		...mapGetters("TokenModule", ["token", "pageInfo", "dealMembers"]),
		totalRaised() {
			const tokenData = this.token.token || this.token;
			const totalRaised = (tokenData.total_raised || 0) * (tokenData.price?.exchange || tokenData.price?.buy || 1);
			return totalRaised;
		},
		dealAccess() {
			return this.token.token?.deal_access;
		},
		supply() {
			const supply = this.token.token
				? this.token.token.supply
				: this.token.supply;
			return supply;
		},
		raiseAmount() {
			const raiseAmount = this.token.token
				? this.token.token.raise_amount
				: this.token.raise_amount;
			return raiseAmount || 0;
		},
    currency() {
      return this.token.currency || 'USD'
    },
		percentageRaised() {
			if (!this.raiseAmount) return 0;
			return ((this.totalRaised / this.raiseAmount) * 100).toFixed(2);
		},
		selectedMembers() {
			const members = this.dealMembers?.slice(0, 6);
			return members;
		},
	},
	watch: {
		token(val) {
			if (val.status === "Approved" && this.dealAccess === "Private") {
				this.getDealMembers(val.token._id);
			}
			this.getAsset(val.asset._id || val.asset);
		},
	},
	created() {
		this.getTokenRequest(this.$route.params.id);
	},
	methods: {
		convertToLocale,
		formatAmountToDollar,
		...mapActions("assetModule", ["getAsset"]),
		...mapActions("TokenModule", ["getDealMembers", "getTokenRequest"]),
		handleMember(val) {
			this.showMemberForm = val;
		},
		setImage(e) {
			e.target.src =
				"https://res.cloudinary.com/djalafcj9/image/upload/v1634012152/getequityV2/header-profile-img_kjtkcq.png";
		},
	},
};
</script>

<style lang="scss" scoped>
.deal-overview {
  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 32px;
    flex-wrap: wrap;
    gap: 16px;
  }
}

.back-link {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 500;
  color: #64748B;
  text-decoration: none;
  transition: color 0.2s ease;
  
  &:hover {
    color: #0F172A;
  }
}

.deal-title {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 28px;
  
  &__image {
    width: 56px;
    height: 56px;
    border-radius: 12px;
    object-fit: cover;
    border: 1px solid #E2E8F0;
  }
  
  &__name {
    font-size: 24px;
    font-weight: 500;
    color: #0F172A;
  }
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 32px;
  
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
}

.stat-card {
  background: #ffffff;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  overflow: hidden;
  
  &--primary {
    background: linear-gradient(135deg, #0F172A 0%, #1E293B 100%);
    border: none;
    
    .stat-card__label {
      color: rgba(255, 255, 255, 0.6);
    }
    
    .stat-card__value,
    .stat-card__value-sm {
      color: #ffffff;
    }
    
    .stat-card__percentage {
      color: rgba(255, 255, 255, 0.5);
    }
    
    .stat-card__footer {
      background: rgba(0, 0, 0, 0.2);
      border-top: 1px solid rgba(255, 255, 255, 0.1);
    }
    
    .stat-item__label {
      color: rgba(255, 255, 255, 0.5);
    }
    
    .stat-item__value {
      color: #ffffff;
    }
  }
  
  &__header {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 20px 24px;
    border-bottom: 1px solid #E2E8F0;
  }
  
  &__content {
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  
  &__main {
    display: flex;
    align-items: flex-start;
    gap: 16px;
  }
  
  &__secondary {
    padding-top: 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  &__icon-wrap {
    width: 48px;
    height: 48px;
    background: rgba(77, 132, 255, 0.2);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4D84FF;
    flex-shrink: 0;
  }
  
  &__icon-sm {
    width: 44px;
    height: 44px;
    background: rgba(77, 132, 255, 0.1);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4D84FF;
    flex-shrink: 0;
  }
  
  &__label {
    font-size: 13px;
    color: #64748B;
    margin-bottom: 6px;
    font-weight: 400;
  }
  
  &__value {
    font-size: 26px;
    font-weight: 500;
    color: #0F172A;
    margin-bottom: 12px;
  }
  
  &__value-sm {
    font-size: 16px;
    font-weight: 500;
    color: #0F172A;
  }
  
  &__progress {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  &__percentage {
    font-size: 13px;
    color: #64748B;
    font-weight: 400;
  }
  
  &__body {
    padding: 20px 24px;
  }
  
  &__footer {
    padding: 16px 24px;
    background: #F8FAFC;
  }
}

.progress-bar {
  height: 6px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 3px;
  overflow: hidden;
  
  &__fill {
    height: 100%;
    background: #4D84FF;
    border-radius: 3px;
    transition: width 0.3s ease;
  }
}

.stat-item {
  &__label {
    display: block;
    font-size: 12px;
    color: #64748B;
    margin-bottom: 4px;
    font-weight: 400;
  }
  
  &__value {
    font-size: 14px;
    font-weight: 500;
    color: #0F172A;
  }
}

.members-list {
  &__avatars {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }
  
  &__add {
    width: 40px;
    height: 40px;
    border: 2px dashed #CBD5E1;
    border-radius: 50%;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4D84FF;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
      border-color: #4D84FF;
      background: rgba(77, 132, 255, 0.05);
    }
  }
}

.content-card {
  background: #ffffff;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  overflow: hidden;
  margin-top: 24px;
  
  &__header {
    padding: 20px 24px;
    border-bottom: 1px solid #E2E8F0;
    overflow-x: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    
    &::-webkit-scrollbar {
      display: none;
    }
  }
  
  &__body {
    padding: 24px;
  }
}

.tabs-nav {
  display: flex;
  gap: 8px;
  min-width: max-content;
  
  &__item {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    font-size: 14px;
    font-weight: 500;
    color: #64748B;
    background: transparent;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    white-space: nowrap;
    transition: all 0.2s ease;
    
    &:hover {
      background: #F1F5F9;
      color: #0F172A;
    }
    
    &--active {
      background: #4D84FF;
      color: #ffffff;
      
      &:hover {
        background: #3B6EE8;
        color: #ffffff;
      }
    }
  }
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  
  &--primary {
    padding: 12px 20px;
    background: #4D84FF;
    color: #ffffff;
    
    &:hover {
      background: #3B6EE8;
    }
  }
  
  &--full {
    width: 100%;
  }
}
</style>
